module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"@root":{"handleWom.exoRun.event":[{"value":"running","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102004},"path":"@root","_fox_":1}],"handleWom.exoRun.widget":[{"value":"@root","lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102005},"path":"@root","_fox_":1}],"handleWom.exoRun.callback":[{"value":function () {
require('services/exodentity')(fox);
fox.exodentity.include();
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102010},"path":"@root","_fox_":1}],"requireResources":[{"value":function () {
return require('../customizations/c11n-switcher')(fox);
},"lWeight":true,"desc":{"level":2,"weightDesc":[],"weight":102013},"path":"@root","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/root.opt
// module id = 169
// module chunks = 5